<template>
  <div class="flex flex-wrap">
    <div class="w-full px-4">
      <div
        class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
      >
        <map-pan />
      </div>
    </div>
  </div>
</template>
<script>
import MapPan from "@/components/Maps/MapPan.vue";

export default {
  components: {
    MapPan,
  },
};
</script>
